<template>
  <div class="empty d-flex justify-content-center align-items-center">
    <div class="d-flex justify-content-center flex-column position-relative">
      <p style="text-align: center;">
        <base-icon icon="search_nomatches" />
      </p>
      <p class="text">
        {{ $t("clients.noResult") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientEmptyMessage',
};
</script>

<style lang="scss" scoped>
.empty {
  background-color: $gray-light;
  flex: 1;
  border-radius: 5px;

  p {
    font-weight: 400;
    color: #1B1B1B;
    font-size: 1rem;
    transform: translateY(-1.5rem);
  }
}
</style>
